// src/routes/RedirectIfSignedIn.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@clerk/clerk-react";

export default function RedirectIfSignedIn({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) return null; // or a loader

  if (isSignedIn) {
    // optional: if user hit /login directly, send to dashboard
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
}